import { render, staticRenderFns } from "./ActionCategory.vue?vue&type=template&id=13b0d9d7"
import script from "./ActionCategory.vue?vue&type=script&lang=js"
export * from "./ActionCategory.vue?vue&type=script&lang=js"
import style0 from "./ActionCategory.vue?vue&type=style&index=0&id=13b0d9d7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports